import { ExpertAdvice } from "@/common/api.service";
import {
  FETCH_EXPERTS,
  FETCH_EXPERTS_LIST,
  FETCH_QUESTIONS_LIST
} from "./actions.type";
import {
  FETCH_EXPERTS_END,
  FETCH_EXPERTS_START,
  FETCH_QUESTIONS_END,
  FETCH_QUESTIONS_START
} from "@/store/mutations.type";

const state = {
  expert: {},
  isExpsLoading: false,
  experts: [],
  isQuestionsLoading: false,
  questions: []
};

const getters = {
  expert() {
    return state.expert;
  },
  isExpsLoading() {
    return state.isExpsLoading;
  },
  experts() {
    return state.experts;
  },
  questions() {
    return state.questions;
  },
  isQuestionsLoading() {
    return state.isQuestionsLoading;
  }
};

const actions = {
  async [FETCH_EXPERTS]({ state }, id) {
    await ExpertAdvice.list(id)
      .then(({ data }) => {
        state.expert = data;
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_EXPERTS_LIST]({ commit }, params) {
    commit(FETCH_EXPERTS_START);
    return ExpertAdvice.getListAdvice(params)
      .then(({ data }) => {
        commit(FETCH_EXPERTS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_QUESTIONS_LIST]({ commit }, params) {
    commit(FETCH_QUESTIONS_START);
    return ExpertAdvice.getProjectAdviceInfo(params.id, params.idRow)
      .then(({ data }) => {
        commit(FETCH_QUESTIONS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_EXPERTS_START](state) {
    state.isExpsLoading = true;
  },
  [FETCH_EXPERTS_END](state, experts) {
    state.experts = experts;
    state.isExpsLoading = false;
  },
  [FETCH_QUESTIONS_START](state) {
    state.isQuestionsLoading = true;
  },
  [FETCH_QUESTIONS_END](state, questions) {
    state.questions = questions;
    state.isQuestionsLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
